(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-portfolio"] && !Shopify.designMode) return;
  try {
    
class ArtPortfolioWithLightbox {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.lightboxEnabled = this.container.dataset.enableLightbox === 'true';
    if (!this.lightboxEnabled) return;
    
    this.lightbox = document.getElementById(`Lightbox-${this.container.dataset.sectionId}`);
    this.imageLinks = this.container.querySelectorAll('.art-portfolio__item-link');
    this.images = Array.from(this.imageLinks).map(link => ({ src: link.href, alt: link.querySelector('img')?.alt || '' }));
    
    if (this.images.length === 0) return;

    this.currentIndex = 0;
    this.init();
  }

  init() {
    this.imageLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.currentIndex = parseInt(link.dataset.index, 10);
        this.open();
      });
    });

    this.lightbox.querySelector('.art-portfolio__lightbox-close').addEventListener('click', () => this.close());
    this.lightbox.querySelector('.art-portfolio__lightbox-backdrop').addEventListener('click', () => this.close());
    this.lightbox.querySelector('.art-portfolio__lightbox-next').addEventListener('click', () => this.next());
    this.lightbox.querySelector('.art-portfolio__lightbox-prev').addEventListener('click', () => this.prev());

    this.container.addEventListener('keydown', (event) => {
      if (!this.lightbox.hasAttribute('open')) return;
      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowRight') this.next();
      if (event.key === 'ArrowLeft') this.prev();
    });
  }

  open() {
    this.updateImage();
    this.lightbox.setAttribute('open', '');
    this.lightbox.focus();
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.lightbox.removeAttribute('open');
    document.body.style.overflow = '';
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.updateImage();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.updateImage();
  }

  updateImage() {
    const { src, alt } = this.images[this.currentIndex];
    const imageElement = this.lightbox.querySelector('.art-portfolio__lightbox-image');
    imageElement.src = src;
    imageElement.alt = alt;

    const prevButton = this.lightbox.querySelector('.art-portfolio__lightbox-prev');
    const nextButton = this.lightbox.querySelector('.art-portfolio__lightbox-next');
    prevButton.disabled = this.images.length <= 1;
    nextButton.disabled = this.images.length <= 1;
  }
}

document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('.art-portfolio-section');
  if (container) new ArtPortfolioWithLightbox(container);
});

document.querySelectorAll('.art-portfolio-section').forEach(container => {
  new ArtPortfolioWithLightbox(container);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();
})();
